import React, { useState } from "react";
import "../App.css";

const FeedbackForm = () => {
  const [formData, setFormData] = useState({
    email: "",
    question1: "",
    question2: "",
    treatmentsTried: "", 
    additionalComments: "",
  });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFeedbackSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitted(false);

    // Basic validation
    if (!formData.email || !formData.email.includes("@")) {
      setError("Please enter a valid email address.");
      return;
    }

    try {
      const res = await fetch("https://7efu8nno5m.execute-api.us-west-1.amazonaws.com/dev/feedback", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.error || "Something went wrong");
      }

      setSubmitted(true);
      setFormData({
        email: "",
        question1: "",
        question2: "",
        additionalComments: "",
      });
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="email-signup">
      <h3>We'd Love Your Feedback</h3>

      <div className="feedback-scroll">
        <form
          onSubmit={handleFeedbackSubmit}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center", // centers all form elements
            textAlign: "center",  // centers text within <p> labels
          }}
        >


          {/* === EMAIL FIELD === */}
          <div style={{ marginBottom: "20px" }}>
            <p style={{
              fontWeight: "600",
              margin: "10px",
              fontSize: "1rem",
              width: "100%",
              textAlign: "left"
            }}>
              Your Email:
            </p>
            <input
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="search-input"
              style={{
                width: "100%",
                minWidth: "300px",
                maxWidth: "450px",
                margin: "0 auto",
                display: "block",
                height: "30px",
              }}
            />
          </div>

          {/* === QUESTION 1 === */}
          <div style={{ marginBottom: "20px" }}>
            <p style={{
              fontWeight: "600",
              margin: "10px",
              fontSize: "1rem",
              width: "100%",
              textAlign: "left"
            }}>
              What did you like or find promising about this platform so far, and what would you want to see more of?
            </p>
            <textarea
              name="question1"
              value={formData.question1}
              onChange={handleChange}
              className="search-input"
              required
              style={{
                width: "100%",
                maxWidth: "450px",
                margin: "0 auto",
                display: "block",
                minHeight: "100px",
              }}
            />
          </div>

          {/* === QUESTION 2 === */}
          <div style={{ marginBottom: "20px" }}>
            <p style={{
              fontWeight: "600",
              margin: "10px",
              fontSize: "1rem",
              width: "100%",
              textAlign: "left"
            }}>
              What parts of the platform felt confusing, missing, or could be improved — and why?
            </p>
            <textarea
              name="question2"
              value={formData.question2}
              onChange={handleChange}
              className="search-input"
              required
              style={{
                width: "100%",
                maxWidth: "450px",
                margin: "0 auto",
                display: "block",
                minHeight: "100px",
              }}
            />
          </div>

          {/* === NEW QUESTION: WHAT HAVE YOU TRIED === */}
          <div style={{ marginBottom: "20px" }}>
            <p
              style={{
                fontWeight: "600",
                margin: "10px",
                fontSize: "1rem",
                width: "100%",
                textAlign: "left"
              }}
            >
              Everyone’s pain story is different. What treatments, therapies, or changes have you tried? 
              Please describe what symptoms or conditions you were treating, what benefits or side effects 
              you noticed, and anything that didn’t work as expected.
            </p>
            <textarea
              name="treatmentsTried"
              value={formData.treatmentsTried}
              onChange={handleChange}
              className="search-input"
              required
              style={{
                width: "100%",
                maxWidth: "450px",
                margin: "0 auto",
                display: "block",
                minHeight: "120px",
              }}
            />
          </div>

          {/* === ADDITIONAL COMMENTS === */}
          <div style={{ marginBottom: "24px" }}>
            <p style={{
              fontWeight: "600",
              margin: "8px",
              fontSize: "1rem",
              width: "100%",
              textAlign: "left"
            }}>
              If we could expand or improve anything to support more people with chronic pain, what would you want to see?
            </p>
            <textarea
              name="additionalComments"
              value={formData.additionalComments}
              onChange={handleChange}
              className="search-input"
              style={{
                width: "100%",
                maxWidth: "450px",
                margin: "0 auto",
                display: "block",
                minHeight: "100px",
              }}
            />
          </div>

          <div style={{ textAlign: "center" }}>
            <button
              type="submit"
              className="summary-button"
              style={{
                width: "100%",        // same width ratio as textboxes
                maxWidth: "450px",   // matches textbox max width
              }}
            >
              Submit Feedback
            </button>


            <p style={{ fontSize: "0.95rem", color: "#546e7a", textAlign: "center", marginTop: "24px" }}>
              Thank you so much for supporting this project. Every story helps our research team make this resource more useful and hopeful for others living with pain.
            </p>

          </div>
        </form>

        {submitted && (
    <div style={{ marginTop: "-30px", marginBottom: "10px", textAlign: "center" }}>
      <p
        className="success"
        style={{
          fontSize: "1.1rem",
          fontWeight: "600",
          color: "#2c3e50",
          marginBottom: "0",
        }}
      >
        Thank you for your feedback!
      </p>
    </div>
  )}
  {error && (
    <p className="error" style={{ textAlign: "center", color: "red", marginBottom: "0" }}>
      {error}
    </p>
  )}

      </div>
    </div>
  );
};

export default FeedbackForm;
